import _ from 'lodash';
import React from 'react';
import { Avatar } from 'src/@vymo/ui/atoms';
import { List } from 'src/@vymo/ui/blocks';
import { useAppDispatch } from 'src/store/hooks';
import { handleSearchNavigation, renderSearchItemDetails } from './queries';
import { SearchDetailsProps } from './types';
import styles from './index.module.scss';

function SearchDetails({ items, type }: SearchDetailsProps) {
  const dispatch = useAppDispatch();

  return (
    <List
      onItemClick={(idx) => handleSearchNavigation(items[idx], type, dispatch)}
      className={styles.search__result}
    >
      {items.map((item) => (
        <List.Item key={item.code} className={styles.search__result__item}>
          <Avatar
            size="small"
            background="var(--background-default)"
            text={_.capitalize(item.name?.charAt(0))}
          />

          <div>{renderSearchItemDetails(item, type)}</div>
        </List.Item>
      ))}
    </List>
  );
}

export default SearchDetails;
